module.exports = __webpack_public_path__ + "icon-resolution.png?67cae88ec7a342333a8478452206c110";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon-resolution.png
// module id = 411
// module chunks = 0